import { API_URL } from 'app/config/envVariables';
import { getAccessToken } from 'entities/User';

export const generatRefundPdfLink = (refundId: string): string => {
  const token = getAccessToken();

  const refundPdfLink = `${API_URL}/billing-documents/payments/refunds/${refundId}/pdf?token=${token}`;

  return refundPdfLink;
};
